module.exports = __webpack_public_path__ + "static/media/nuestnsm.cc40cb81.jpg";